import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import moment from 'moment';
import queryString from 'qs';
import _ from 'lodash'
import {
  Search,
  TextArea,
  DatePicker,
  DatePickerInput,
  FormItem,
  Accordion,
  AccordionItem,
  TextInput
} from 'carbon-components-react';
import RadioButton from 'carbon-components-react/lib/components/RadioButton';
import { Breadcrumb, TableDefault, Tabs, Notification, SearchInput } from '../../../../../components';
import ModalDm from '../../../../../components/Modal/ModalDm';
import DatePickerDm from '../../../../../components/DatePicker'
import { getDmService, insertDmService, pathDmService, updateDmService, getPedidosAtrasados } from '../../../../../services/Api';

import { Administrador } from '../../../../../config/UserStatusLevel';

import {
  EmTransporte,
  FechamentoDeArquivo,
  Finalizado,
} from '../../../../../config/StatusPedido';

class List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      search: "",
      search2: "",
      search3: "",
      pageSize: 100,
      totalItems: 0,
      orderBy: 'default',
      order: '',
      urlDelete: '/ModeloCategoria/Delete/',
      urlEdit: '/admin/agencia/pedido/',
      urlLoad: '/Pedido/GetAgenciaAtendente/',
      user: JSON.parse(localStorage.getItem('user')) || { nivel: {} },
      page: 1,
      openMd: false,
      listStatus: [],
      idsRequests: [],
      listDesigners: [],
      listPriority: [
        { id: 0, label: "Não" },
        // { id: 0, label: "Indefinido" },
        // { id: 2, label: "Baixa" },
        // { id: 3, label: "Média" },
        // { id: 1, label: "Alta" }
        { id: 1, label: "Sim" }
      ],
      listRedatora: [
        { id: 0, label: "Não" },
        { id: 1, label: "Sim" }
      ],
      mdCancel: false,
      mdAprov: false,
      mdDevolv: false,
      selectedAll: false,
      params: null,
      motivoCancel: "",
      motivoDevolver: "",
      warnDataRequired: false,
      dataInicio: "",
      dataFim: "",
      openMdEquipe: false,
      openMdSolicitante: false,
      mdSupTrade: false,
      solicitantes: [],
      idSolicitante: 0,
      searchSolicitante: "",
      equipes: [],
      idEquipe: 0,
      width: 0,
      openModalFinalizarPedido: false,
      modalAlertDesigner: false,
      pedidosAtrasados: []
    }
  }

  componentWillMount = async () => {
    await this.load();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.checkPedidosAtrasados();
  }

  checkPedidosAtrasados = async () => {
    try {
      const pedidos = await getPedidosAtrasados();
      if (pedidos && pedidos.length > 0) {
        this.setState({
          modalAlertDesigner: true,
          pedidosAtrasados: pedidos
        });
      }
    } catch (error) {
      console.log("Erro ao verificar pedidos atrasados", error);
    }
  }

  toggleModalAlertDesigner = () => {
    this.setState(prevState => ({
      modalAlertDesigner: !prevState.modalAlertDesigner
    }));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  load = async () => {
    const { history } = this.props;
    history.listen(async (location) => {
      // console.log("mudou a url");
      if (this.tableList) {
        this.tableList.clearSelectAll();
      }

      this.setState({ idsRequests: [], selectedAll: false })
      await this.getFilters(location)
      await this.updateListStatus(this.props);
    });
    await this.getFilters();

    this.getDesigners();

    this.loadSolicitante();
    await this.updateListStatus(this.props);
    this.getEquipes()
  }

  componentWillReceiveProps = (receivProps) => {
    // console.log(receivProps)
    this.updateListStatus(receivProps);
  }

  selectedRow = selecteds => {
    // console.log("selecteds", selecteds)
    const { ids, rows } = selecteds;
    if (ids.length) {
      const valuesSelecteds = ids.map((item, index) => (
        {
          id: parseInt(item, 10),
          numberRequest: rows[index].cells[0].value,
          solicitante: rows[index].cells[2].value,
          loja: rows[index].cells[3].value,
          produto: rows[index].cells[4].value,
          selected: null,
          priority: null,
          estimated: "",
          redatora: 0
        }
      ));
      // console.log("valuesSelecteds", valuesSelecteds)
      if (valuesSelecteds.length) {
        this.setState(prevState => ({
          selectedAll: !prevState.selectedAll,
          idsRequests: valuesSelecteds
        }))
      }
    } else {
      this.tableList.clearSelectAll();
      this.setState({
        selectedAll: false,
        idsRequests: []
      })
    }
  }

  changeDate = (type, date) => {
    let valueDate = ""
    if (date[0]) {
      // console.log(date)
    } else {
      valueDate = date.target.value
    }

    this.setState(p => ({
      data: {
        ...p.data,
        [type]: {
          server: date ? date[0] : date,
          view: date[0] ? moment(date[0]).format('DD/MM/YYYY') : valueDate,
        },
      },
    }));

    this.updateListStatus(this.props);
  }

  loadSolicitante = async () => {
    const { match } = this.props;
    const { searchSolicitante } = this.state;
    try {
      const solicitantes = await getDmService(`/Equipe/Usuarios?q=${searchSolicitante}`);
      this.setState({
        solicitantes,
      });
    } catch (e) {
      if (match.params.id > 0)
        toast.error("Ocorreu um erro ao carregar os dados");
    }
  }

  getEquipes = async () => {
    try {
      const equipes = await getDmService('/Equipe/GetAtivas');
      await this.setState({ equipes: equipes || [] });
    } catch (error) {
      console.log(error);
    }
  }

  delegaSolicitante = async () => {
    const { idsRequests, idSolicitante } = this.state
    try {
      await updateDmService('/Pedido/DelegaSolicitante', idSolicitante, { pedidos: idsRequests.map(p => p.id) });
      this.openDesignarSolicitante();
      toast.success("Dados atualizados com sucesso");
      this.load();
    } catch (e) {
      toast.error("Ocorreu uma falha ao salvar os dados");
    }
  }

  delegaEquipe = async () => {
    const { idsRequests, idEquipe } = this.state
    try {
      await updateDmService('/Pedido/DelegaEquipe', idEquipe, { pedidos: idsRequests.map(p => p.id) });
      this.openDesignarEquipe();
      toast.success("Dados atualizados com sucesso");
      this.load();
    } catch (e) {
      toast.error("Ocorreu uma falha ao salvar os dados");
    }
  }

  onSearchSolicitanteChange = event => {
    clearTimeout(this.searchTimeout);
    const { value } = event.target;
    this.setState({ searchSolicitante: value, page: 1 });
    this.searchTimeout = setTimeout(() => {
      this.setState(
        {
          searchSolicitante: value || ""
        },
        () => {
          this.loadSolicitante();
        }
      );
    }, 1800);
  };

  onSearchChange = (event, name) => {
    clearTimeout(this.searchTimeout);
    const { value } = event.target;
    this.setState({ [name]: value, page: 1 });
    this.searchTimeout = setTimeout(() => {
      this.setState(
        {
          [name]: value || "",
          page: 1
        },
        () => {
          this.updateListStatus(this.props);
        }
      );
    }, 1800);
  };

  openMdCancel = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        mdCancel: !prevState.mdCancel
      }));
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  openMdDevolv = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        mdDevolv: !prevState.mdDevolv
      }));
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  };

  openEnviarTriagem = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        mdAprov: !prevState.mdAprov
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  cancel = async () => {
    const { idsRequests, motivoCancel } = this.state;
    const idsCancel = idsRequests.map(item => item.id);

    if (idsRequests.length) {
      try {
        await pathDmService(`/Pedido/AtualizaStatusPedidoAgencia`,
          {
            status: 5,
            lstIdPedido:
              idsCancel,
            Mensagem: motivoCancel
          });
        await this.openMdCancel()
        await this.tableList.getItems()
      } catch (error) {
        toast.error("Um erro inesperado ocorreu ao tentar atualizar o status");
        console.log(error);
      }
    }
  }

  devolv = async () => {
    const { idsRequests, motivoDevolver } = this.state;
    const idsCancel = idsRequests.map(item => item.id);

    if (idsRequests.length) {
      try {
        await pathDmService(`/Pedido/AtualizaStatusPedidoAgencia`,
          {
            status: 4,
            lstIdPedido:
              idsCancel,
            Mensagem: motivoDevolver
          });
        await this.openMdDevolv()
        await this.tableList.getItems()
      } catch (error) {
        toast.error("Um erro inesperado ocorreu ao tentar atualizar o status");
        console.log(error);
      }
    }
  }


  enviarSupTrade = async () => {
    const { idsRequests } = this.state;
    const idsCancel = idsRequests.map(item => item.id);

    if (idsRequests.length) {
      try {
        await pathDmService(`/Pedido/AtualizaStatusPedidoAgencia`,
          {
            status: 32,
            lstIdPedido: idsCancel,
          });
        await this.openMdSupTrade()
        await this.tableList.getItems()
      } catch (error) {
        toast.error("Um erro inesperado ocorreu ao tentar atualizar o status");
        console.log(error);
      }
    }
  }

  enviarTriagem = async () => {
    const { idsRequests } = this.state;
    const idsCancel = idsRequests.map(item => item.id);

    if (idsRequests.length) {
      try {
        await pathDmService(`/Pedido/AtualizaStatusPedidoAgencia`,
          {
            status: 16,
            lstIdPedido: idsCancel,
          });
        await this.openEnviarTriagem()
        await this.tableList.getItems()
      } catch (error) {
        toast.error("Um erro inesperado ocorreu ao tentar atualizar o status");
        console.log(error);
      }
    }
  }

  getDesigners = async () => {
    try {
      const data = await getDmService('/Usuario/GetDesigners');
      const designers = data.map(item => ({ id: item.id, label: item.nome }))
      if (designers.length) {
        await this.setState({
          listDesigners: designers,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  onChangeDesigner = (selected, idx) => {
    const { idsRequests } = this.state;
    const dados = _.clone(idsRequests, true);
    dados[idx].selected = selected;
    this.setState({
      idsRequests: dados
    }, () => {
      this.checkDesignersOK()
    });
  }

  onChangeRedatora = (selected, idx) => {
    const { idsRequests } = this.state;
    const dados = _.clone(idsRequests, true);
    dados[idx].redatora = selected;
    this.setState({
      idsRequests: dados
    }, () => {
      this.checkDesignersOK()
    });
  }

  onChangePriority = (selected, idx) => {
    const { idsRequests } = this.state;
    const dados = _.clone(idsRequests, true);
    dados[idx].priority = selected;
    this.setState({
      idsRequests: dados
    }, () => {
      this.checkDesignersOK()
    })
  }

  onChangeEstimated = (date, id) => {
    const newDate = date ? moment(date[0]).format('DD/MM/YYYY') : date;
    const { idsRequests } = this.state;
    idsRequests.find(p => p.id === id).estimated = newDate;
    const newList = idsRequests;
    this.setState({
      idsRequests: newList
    }, () => {
      this.checkDesignersOK()
    })
  }

  checkDesignersOK = () => {
    const { idsRequests } = this.state;
    const ids = this.getIds();
    this.setState({ warnDataRequired: ids.length !== idsRequests.length })
  }

  getIds = () => {
    const { idsRequests } = this.state;

    const ids = idsRequests.filter(item => (
      typeof item === "object" && Object.prototype.hasOwnProperty.call(item, "selected") && typeof item.selected === "object"
      /* && Object.prototype.hasOwnProperty.call(item, "priority") && typeof item.priority === "object" */
      && item.estimated !== ""
    ));
    return ids;
  }

  delegateToDesigner = async () => {
    const { idsRequests } = this.state;
    const ids = this.getIds();

    const list = ids.map(item => (
      {
        IdPedido: item.id,
        IdDesigner: item.selected.id,
        isRedatora: item.redatora.id,
        DataEstimada: item.estimated,
        Prioridade: item.priority ? item.priority.id : 0
      }
    ));

    const formData = {
      lst: list
    }

    if (ids.length === idsRequests.length) {
      try {
        await insertDmService('/Pedido/DelegaDesigner', formData)
        toast.success("Os pedidos foram delegados conforme o solicitado");
        await this.openMdCriacao();
        await this.load();
        this.setState({ warnDataRequired: false })
      } catch (error) {
        this.errorHandler(error);
        await this.openMdCriacao();
      }
    } else {
      this.setState({ warnDataRequired: true })
    }
  }

  errorHandler = err => {
    const existError = Object.prototype.hasOwnProperty.call(err, "error");
    const existResponse = existError ? Object.prototype.hasOwnProperty.call(err.error, "response") : false;
    const existData = existResponse ? Object.prototype.hasOwnProperty.call(err.error.response, "data") : false;
    if (err.error && existError && existResponse && existData && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } if (err.message)
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  openMdCriacao = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        openMd: !prevState.openMd
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }


  openMdSupTrade = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        mdSupTrade: !prevState.mdSupTrade
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }


  openDesignarEquipe = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        openMdEquipe: !prevState.openMdEquipe
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  openDesignarSolicitante = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        openMdSolicitante: !prevState.openMdSolicitante
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  atualizarParaEntregueModal = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState({ openModalFinalizarPedido: true })
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  trocaStatusPedidoEntregue = async () => {
    const { idsRequests, responsavelRecebimento, responsavelEntrega, diaEntrega } = this.state;
    try {
      if (!responsavelEntrega) {
        toast.warn("Informe o nome do responsável pela entrega");
        return;
      }

      if (!diaEntrega) {
        toast.warn("Informe a data de chegada");
        return;
      }

      if (!responsavelRecebimento) {
        toast.warn("Informe o nome do responsável pelo recebimento");
        return;
      }

      const obj = {
        "status": Finalizado,
        responsavelRecebimento,
        responsavelEntrega,
        dataEntregaFornecedor: moment(diaEntrega).format("MM-DD-YYYY"),
        lstIdPedido: idsRequests.map(r => r.id)
      };

      await updateDmService('/Pedido/AtualizaStatusItemPedidoAgenciaPorPedidos', "", obj);
      this.setState({ motivoDevolver: "", idsRequests: [], responsavelRecebimento: "", responsavelEntrega: "", diaEntrega: "" });
      this.toggleModal("openModalFinalizarPedido");
      toast.success(idsRequests.length > 1 ? "Pedidos atualizados com sucesso" : "Pedido atualizado com sucesso");
      this.load();

    } catch (e) {
      this.errorHandler(e);
    }
  }

  getFilters = async (newLocation) => {
    const { history, location } = this.props;
    const { push } = history;
    const { pathname } = location

    try {
      const filters = await getDmService('/Pedido/GetFiltrosAgenciaAtendente');
      if (((newLocation && newLocation.pathname) || pathname) === "/admin/agencia/pedidos") {
        await push(`/admin/agencia/pedidos/${filters[0].location}`)
      }

      await this.setState({ filters, listStatus: filters });
    } catch (error) {
      console.log(error);
    }
  }

  changeDateInit = (date) => {
    this.setState({ dataInicio: date }, () => {
      this.updateListStatus(this.props);
    });
  }

  onChangeCheckEquipe = (idEquipe) => {
    this.setState({ idEquipe });
  }

  changeDateFinish = (date) => {
    this.setState({ dataFim: date }, () => {
      this.updateListStatus(this.props);
    });
  }

  updateListStatus = props => {
    const { location } = props;
    const { search, search2, search3, filters, dataInicio, dataFim } = this.state;
    const currentURl = location.pathname;
    const statusCurrent = currentURl.split('/')[4];
    const initDate = moment(dataInicio).format();
    const finishDate = moment(dataFim).format()
    if (filters) {
      const statusRequests = filters.map(item => item.location)

      if (statusRequests.length) {

        let urlCurrent = "prioridade=1&";
        for (const item of statusRequests) {
          let currentItem = `${item}=false&`
          if (item === statusCurrent) {
            currentItem = `${item}=true&`
          }
          urlCurrent += currentItem
        }

        if (search !== "") {
          urlCurrent = `${urlCurrent}busca=${search}`;
        }

        if (search2 !== "") {
          urlCurrent = `${urlCurrent}&busca2=${search2}`;
        }
        if (search3 !== "") {
          urlCurrent = `${urlCurrent}&busca3=${search3}`;
        }

        if (dataInicio || dataFim) {
          urlCurrent = `${urlCurrent}&dataInicio=${initDate}&dataFim=${finishDate}`
        }
        const query = queryString.parse(location.search.slice(1));

        if (query && query.prioridade) {
          urlCurrent += `&prioridade=${query.prioridade}`;
        }
        if (query && query.designer) {
          urlCurrent += `&designer=${query.designer}`;
        }
        if (query && query.filtrarpor) {
          urlCurrent += `&filtrarpor=${query.filtrarpor}`;
        }
        if (query && query.dtIniDesigner) {
          urlCurrent += `&dtIniDesigner=${query.dtIniDesigner}`;
        }
        if (query && query.dtFimDesigner) {
          urlCurrent += `&dtFimDesigner=${query.dtFimDesigner}`;
        }

        this.setState({
          params: urlCurrent
        }, async () => {
          this.tableList.getItems();
        })
      }
    }
  }

  onChangeSolicitante = idSolicitante => {
    this.setState({ idSolicitante })
  }

  onChangeText = (event) => {
    const { target } = event;
    const { value, id } = target;

    this.setState({
      [id]: value
    });
  }

  onChangeDateTest = (date, name) => {
    this.setState({ [name]: date });
  };

  toggleModal = (modal) => {
    this.setState(prevState => ({
      [modal]: !prevState[modal]
    }));
  }

  renderRequestsSelecteds = () => {
    const { idsRequests, listDesigners, listRedatora, listPriority } = this.state;

    return idsRequests.map((item, index) => (
      <div key={item.id} className="small-text-block bx--row list-actions-md-create-agency">
        <div className="bx--col-md-1 bx--col-xs-12">
          <small>{item.numberRequest}</small>
        </div>
        <div className="bx--col-md-1 bx--col-xs-12">
          <small>{item.solicitante || "N/I"}</small>
        </div>
        <div className="bx--col-md-3 bx--col-xs-12">
          <small>{item.loja || "N/I"}</small>
        </div>
        <div className="bx--col-md-1 bx--col-xs-12">
          <small>{item.produto}</small>
        </div>
        <div className="bx--col-md-2 bx--col-xs-12">
          <Select
            className="search-dm"
            name="product"
            options={listDesigners}
            value={item.selected}
            onChange={e => this.onChangeDesigner(e, index)}
            placeholder="Digite ou selecione"
            isClearable={false}
            isSearchable
          />
        </div>
        <div className="bx--col-md-1 bx--col-xs-12">
          <Select
            className="search-dm"
            name="product"
            options={listRedatora}
            value={item.redatora}
            onChange={e => this.onChangeRedatora(e, index)}
            placeholder="Digite ou selecione"
            isClearable={false}
            isSearchable
          />
        </div>
        <div className="bx--col-md-1 bx--col-xs-12">
          <Select
            className="search-dm"
            name="product"
            options={listPriority}
            value={item.priority}
            onChange={e => this.onChangePriority(e, index)}
            placeholder="Digite ou selecione"
            isClearable={false}
            isSearchable
          />
        </div>
        <div className="bx--col-md-2 bx--col-xs-12">
          <DatePicker
            id="date-pickerI"
            className="f-rigth"
            datePickerType="single"
            dateFormat="d/m/Y"
            locale="pt"
            onChange={e => this.onChangeEstimated(e, item.id)}
            value=""
          >
            <div>
              <DatePickerInput
                name={`dataEstimada${item.id}`}
                id={`dataEstimada${item.id}`}
                labelText=""
                pattern="d{1,2}/d{4}"
                placeholder="dd/mm/aaaa"
                onChange={e => this.onChangeEstimated(e, item.id)}
                value={item.estimated}
              />
            </div>
          </DatePicker>
        </div>
        {JSON.stringify(index)}
      </div>
    ));
  }

  render() {
    const {
      pageSize,
      openMd,
      totalItems,
      orderBy,
      order,
      urlDelete,
      urlEdit,
      urlLoad,
      page,
      search,
      search2,
      search3,
      listStatus,
      mdCancel,
      params,
      motivoCancel,
      mdDevolv,
      mdAprov,
      motivoDevolver,
      user,
      warnDataRequired,
      dataInicio,
      dataFim,
      openMdSolicitante,
      openMdEquipe,
      solicitantes,
      idSolicitante,
      idEquipe,
      equipes,
      searchSolicitante,
      width,
      openModalFinalizarPedido,
      responsavelEntrega,
      responsavelRecebimento,
      nivel,
      statusId,
      diaEntrega,
      mdSupTrade
    } = this.state;
    const { match, location } = this.props;

    const notSearch = true;
    const disabled = true;

    const isDesigner = user && user.nivel ? user.nivel.id === 40 : disabled;
    const isGerente = user && user.nivel ? user.nivel.id === 45 : disabled;
    const userRestrict = isGerente || isDesigner;
    const { pathname } = location
    const isAdmin = user.nivel.id === 10;
    const statusCurrent = pathname.split("/")[4];

    const userValues = JSON.parse(localStorage.getItem("user"));
    const { agencia, trade, comunicacao, cadastros } = (userValues || {});
    const isAdminTrade = !agencia && nivel === Administrador && trade;
    const isAdminComunication = comunicacao === true && nivel === Administrador && !agencia;
    const isAdminCadastro = cadastros && nivel === Administrador && !agencia;
    // eslint-disable-next-line no-unused-vars
    const isAdminEspecial = isAdminTrade || isAdminComunication || isAdminCadastro;

    let ulrStatusCurrent = "";
    if (params) {
      params.split("&").forEach((element) => {
        if (element.indexOf("=true") > -1) {
          ulrStatusCurrent = element.substring(0, element.indexOf("=true"));
        }
      });
    }

    return (
      <div>
        <Breadcrumb
          title="Pedidos de Agência"
          description="Gerencie os pedidos de produtos"
        />
        <div className="content-wrapper budget-management">
          <Accordion className="accordion-pedidos">
            <AccordionItem
              title={width >= 1024 ? "" : "Filtros e Ações"}
              open={width >= 1024}
              renderExpando={() => (<p />)}
            >

              {isAdmin && (
                <div className="bx--row filters-news-requests">
                  <div className="bx--col-md-6 bx--col-xs-12">
                    <Search
                      className="search-request-agency campoPedido some-class"
                      id="search-3"
                      name="busca"
                      value={search3}
                      onChange={e => this.onSearchChange(e, 'search3')}
                      labelText="Busca Geral Por Pedido"
                      placeHolderText="Busca Geral Por Pedido"
                    />
                  </div>
                </div>
              )}


              <div className="bx--row filters-news-requests">

                <div className="bx--col-md-3 bx--col-xs-12">
                  <Search
                    className="search-request-agency campoPedido some-class"
                    id="search-1"
                    name="busca"
                    value={search}
                    onChange={e => this.onSearchChange(e, 'search')}
                    labelText="Filtrar por"
                    placeHolderText="Filtrar por"
                  />
                </div>
                <div className="bx--col-md-3 bx--col-xs-12">
                  <Search
                    className="search-request-agency campoPedido some-class"
                    id="search-2"
                    name="busca"
                    value={search2}
                    onChange={e => this.onSearchChange(e, 'search2')}
                    labelText="Filtrar por"
                    placeHolderText="Filtrar por"
                  />
                </div>
                <div className="bx--col-md-3 bx--col-xs-12 ">
                  <div className="filter-request-agency">
                    <FormItem className="date-init">
                      <label className="bx--label">
                        Data de solicitação
                      </label>
                      <DatePickerDm
                        id="dataInicioFormatada"
                        date={dataInicio ? moment(dataInicio) : ""}
                        locale="pt"
                        onDateChange={date => this.changeDateInit(date)}
                        placeholder="DD/MM/YYYY"
                        isOutsideRange={() => false}
                      />
                    </FormItem>
                  </div>
                </div>
                <div className="bx--col-md-3 bx--col-xs-12 ">
                  <div className="filter-request-agency and-before">
                    <FormItem className="date-finish">
                      <DatePickerDm
                        id="dataInicioFormatada"
                        date={dataFim ? moment(dataFim) : ""}
                        locale="pt"
                        onDateChange={date => this.changeDateFinish(date)}
                        placeholder="DD/MM/YYYY"
                        isOutsideRange={() => false}
                      />
                    </FormItem>
                  </div>
                </div>
              </div>
              {!isGerente && (
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <Tabs
                      sections={
                        listStatus.map(item => (
                          { title: item.title, path: `${match.url}/${item.location}` }
                        ))
                      }
                    // onClick={() => this.updateListStatus(this.props)}
                    />
                  </div>
                </div>
              )}
              <div className="bx--row">
                <div className="bx--col-md-12 bx--col-xs-12">
                  <div className="f-right">
                    {((statusCurrent === "triagem" || statusCurrent === "criacao" || statusCurrent === "redacao") && !userRestrict) && (
                      <React.Fragment>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.openMdCriacao()}
                        >
                          {((statusCurrent === "triagem" ? "Criação" : "Alterar Designer/Data de entrega"))}
                        </button>
                      </React.Fragment>
                    )}

                    {(statusCurrent === "triagem" && !userRestrict) && (
                      <React.Fragment>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.openMdSupTrade()}
                        >
                          Supervisão trade
                        </button>
                      </React.Fragment>
                    )}

                    {/* {((statusCurrent === "triagem" || statusCurrent === "supervisaoTrade") && !userRestrict) && ( */}
                    {((statusCurrent !== "finalizado" || statusCurrent === "devolvido") && !userRestrict) && (
                      <React.Fragment>
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => this.openMdDevolv()}
                        >
                          Devolver
                        </button>
                      </React.Fragment>
                    )}
                    {(statusCurrent === "supervisaoTrade" && !userRestrict) && (
                      <React.Fragment>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.openEnviarTriagem()}
                        >
                          Enviar Triagem
                        </button>
                      </React.Fragment>
                    )}
                    {(statusCurrent === "triagem" && !userRestrict) && (
                      <button
                        className="bx--btn btn-primary-outlined h-sm-margin"
                        type="button"
                        onClick={() => this.openMdCancel()}
                      >
                        Cancelar
                      </button>
                    )}
                    {isAdmin && (
                      <React.Fragment>
                        {(statusCurrent && statusCurrent.toLowerCase() === "fornecedor") && (
                          <button
                            className="bx--btn btn-secondary-color h-sm-margin"
                            type="button"
                            onClick={() => this.atualizarParaEntregueModal()}
                          // onClick={() => this.finalizar()}
                          >
                            Finalizar Pedido
                          </button>)}
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.openDesignarEquipe()}
                        >
                          Alterar Equipe
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={() => this.openDesignarSolicitante()}
                        >
                          Alterar Solicitante
                        </button>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
          <div className={`screen-table-agency table-${statusCurrent}`}>
            {params && ulrStatusCurrent === statusCurrent && (
              <TableDefault
                notSearch={notSearch}
                params={params}
                search={search}
                order={order}
                orderBy={orderBy}
                page={page}
                pageSize={pageSize}
                totalItems={totalItems}
                urlDelete={urlDelete}
                urlEdit={urlEdit}
                urlLoad={urlLoad}
                onRef={ref => {
                  this.tableList = ref;
                }}
                onRowSelected={(statusCurrent === "triagem" && !userRestrict) || isAdmin ? rows => {
                  this.selectedRow(rows);
                } : undefined}
                displayActions={false}
                currentPage={statusCurrent}
              />
            )}
          </div>
        </div>
        <div className="md-agency">
          <ModalDm
            openModal={this.openMdCriacao}
            heading="Delegar para Designer"
            hiddenModal={this.openMdCriacao}
            openMd={openMd}
          >
            <div>
              <p className="question">
                {`Para qual `}
                <strong>designer</strong>
                {` você deseja delegar este pedido?`}
              </p>
              <br />

              <div className="bx--row">
                <div className="bx--col-md-1">
                  <label className="bx--label">Nr. Pedido</label>
                </div>
                <div className="bx--col-md-1">
                  <label className="bx--label">Solicitante</label>
                </div>
                <div className="bx--col-md-3">
                  <label className="bx--label">Loja</label>
                </div>
                <div className="bx--col-md-1">
                  <label className="bx--label">Produtos</label>
                </div>
                <div className="bx--col-md-2 bx--col-xs-12">
                  <label className="bx--label">Designer</label>
                </div>
                <div className="bx--col-md-1 bx--col-xs-12">
                  <label className="bx--label">Redatora</label>
                </div>
                <div className="bx--col-md-1 bx--col-xs-12">
                  <label className="bx--label">Prioridade</label>
                </div>
                <div className="bx--col-md-2 bx--col-xs-12">
                  <label className="bx--label">Data estimada</label>
                </div>
              </div>

              {this.renderRequestsSelecteds()}
              {warnDataRequired &&
                (
                  <div className="bx--row">
                    <div className="bx--col-xs-12 bx--col-md-12 bx--col-sm-12 v-md-margin">
                      <Notification
                        kind="warning"
                        title="Atenção"
                        description="Você precisa delegar designers, redatores e datas para todos os selecionados."
                      />
                    </div>
                  </div>
                )
              }
              <div className="bx--row btn-actions">
                <div className="bx--col-md-12 bx--col-xs-12">
                  <div className="f-right">
                    <button
                      className="bx--btn btn-secondary-outlined h-sm-margin"
                      type="button"
                      onClick={() => this.openMdCriacao()}
                    >
                      Cancelar
                    </button>
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      type="button"
                      onClick={() => this.delegateToDesigner()}
                    >
                      Confirmar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ModalDm>
        </div>
        {/* Modal Cancelar pedido */}
        <div className="md-cancel-request-agency">
          <ModalDm
            openModal={this.openMdCancel}
            heading="Você tem certeza que deseja cancelar os pedidos selecionados?"
            hiddenModal={this.openMdCancel}
            openMd={mdCancel}
          >
            <div className="bx--row btn-actions">
              <div className="bx--col-md-12 bx--col-xs-12">
                <TextArea
                  labelText=""
                  id="motivoCancel"
                  value={motivoCancel}
                  onChange={e => this.onChangeText(e)}
                  placeholder="Digite aqui o motivo"
                />
              </div>
              <div className="bx--col-md-12 bx--col-xs-12 mg-top-40">
                <div className="f-right">
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    type="button"
                    onClick={() => this.openMdCancel()}
                  >
                    Não
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.cancel()}
                    disabled={motivoCancel === "" ? disabled : !disabled}
                  >
                    Sim
                  </button>
                </div>
              </div>
            </div>
          </ModalDm>
        </div>
        {/* Modal devolver pedido */}
        <div className="md-cancel-request-agency">
          <ModalDm
            openModal={this.openMdDevolv}
            heading="Você tem certeza que deseja devolver os pedidos selecionados?"
            hiddenModal={this.openMdDevolv}
            openMd={mdDevolv}
          >
            <div className="bx--row btn-actions">
              <div className="bx--col-md-12 bx--col-xs-12">
                <TextArea
                  labelText=""
                  id="motivoDevolver"
                  value={motivoDevolver}
                  onChange={e => this.onChangeText(e)}
                  placeholder="Digite aqui o motivo"
                />
              </div>

              <div className="bx--col-md-12 bx--col-xs-12 mg-top-40">
                <div className="f-right">
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    type="button"
                    onClick={() => this.openMdDevolv()}
                  >
                    Não
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.devolv()}
                    disabled={motivoDevolver === "" ? disabled : !disabled}
                  >
                    Sim
                  </button>
                </div>
              </div>
            </div>
          </ModalDm>
        </div>
        <div className="md-cancel-request-agency">
          <ModalDm
            openModal={this.openMdSupTrade}
            heading="Você tem certeza que deseja Enviar para Supervisão Trade este pedido?"
            hiddenModal={this.openMdSupTrade}
            openMd={mdSupTrade}
          >
            <div className="bx--row btn-actions">
              <div className="bx--col-md-12 bx--col-xs-12 mg-top-40">
                <div className="f-right">
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    type="button"
                    onClick={() => this.openMdSupTrade()}
                  >
                    Não
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.enviarSupTrade()}
                  >
                    Sim
                  </button>
                </div>
              </div>
            </div>
          </ModalDm>
        </div>
        {/* Encaminhar pedido para triagem */}
        <div className="md-cancel-request-agency">
          <ModalDm
            openModal={this.openEnviarTriagem}
            heading="Você tem certeza que deseja mandar os pedidos selecionados para triagem?"
            hiddenModal={this.openEnviarTriagem}
            openMd={mdAprov}
          >
            <div className="bx--row btn-actions">
              <div className="bx--col-md-12 bx--col-xs-12 mg-top-40">
                <div className="f-right">
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    type="button"
                    onClick={() => this.openEnviarTriagem()}
                  >
                    Não
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.enviarTriagem()}
                  >
                    Sim
                  </button>
                </div>
              </div>
            </div>
          </ModalDm>

          <ModalDm
            openModal={this.openDesignarEquipe}
            heading="Selecione a Equipe"
            hiddenModal={this.openDesignarEquipe}
            openMd={openMdEquipe}
          >
            <div>
              <div className="bx--modal-content" style={{ maxHeight: 360 }}>
                <div className="bx--row">
                  <div className="bx--col-md-12">
                    <RadioButton
                      name="equipe"
                      labelText="Nenhuma"
                      checked={idEquipe === 0}
                      onClick={() => this.onChangeCheckEquipe(0)}
                    />
                  </div>
                </div>
                {equipes.map(equipe => (
                  <div className="bx--row">
                    <div className="bx--col-xs-12" style={{ marginTop: 10 }}>
                      <RadioButton
                        name="equipe"
                        checked={idEquipe === equipe.id}
                        labelText={equipe.nome}
                        onClick={() => this.onChangeCheckEquipe(equipe.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bx--modal-footer">
              <div className="bx--row btn-actions">
                <div className="bx--col-md-12 bx--col-xs-12">
                  <div className="f-right">
                    <button
                      className="bx--btn btn-secondary-outlined h-sm-margin"
                      type="button"
                      onClick={this.openDesignarEquipe}
                    >
                      Cancelar
                    </button>
                    <button
                      className="bx--btn btn-secondary-color h-sm-margin"
                      type="button"
                      onClick={async () => this.delegaEquipe()}
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ModalDm>

          <ModalDm
            openModal={this.openDesignarSolicitante}
            heading="Selecione o Solicitante"
            hiddenModal={this.openDesignarSolicitante}
            openMd={openMdSolicitante}
          >
            <div>
              <div className="bx--modal-content">
                <div className="bx--row">
                  <div className="bx--col-md-12">
                    <FormItem className="select-full-width">
                      <SearchInput onChange={this.onSearchSolicitanteChange} value={searchSolicitante} placeholder="Buscar por nome" />
                    </FormItem>
                  </div>
                </div>
                <div style={{ maxHeight: 360, overflow: "auto" }}>
                  {solicitantes && solicitantes.map(item => (
                    <div className="bx--row" key={`k${item.id}`} style={{ marginTop: 10 }}>
                      <div className="bx--col-md-12">
                        <FormItem>
                          <RadioButton
                            name="fornecedor"
                            onChange={() => { this.onChangeSolicitante(item.id) }}
                            checked={idSolicitante === item.id}
                            value={item.id}
                            labelText={item.nome}
                          />
                        </FormItem>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bx--modal-footer">
                <div className="bx--row btn-actions">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <div className="f-right">
                      <button
                        className="bx--btn btn-secondary-outlined h-sm-margin"
                        type="button"
                        onClick={this.openDesignarSolicitante}
                      >
                        Cancelar
                      </button>
                      <button
                        className="bx--btn btn-secondary-color h-sm-margin"
                        type="button"
                        onClick={async () => this.delegaSolicitante()}
                        disabled={idSolicitante === 0}
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalDm>

          <ModalDm
            openModal={() => { this.toggleModal('openModalFinalizarPedido') }}
            heading="Atualizar para 'Entregue'"
            hiddenModal={() => { this.toggleModal('openModalFinalizarPedido') }}
            openMd={openModalFinalizarPedido}
          >
            <div>
              <div className="bx--modal-header">
                <p className="question">
                  {statusId !== EmTransporte && (<React.Fragment>Você tem certeza que deseja definir este pedido como entregue?</React.Fragment>)}
                  {[FechamentoDeArquivo, EmTransporte].includes(statusId) && (<React.Fragment>Informe para quem foi enviado o arquivo.</React.Fragment>)}
                </p>
              </div>

              <div className="bx--modal-content">
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <FormItem>
                      <label>Data da entrega</label>
                      <DatePickerDm
                        id="diaEntrega"
                        name="diaEntrega"
                        placeholder="DD/MM/YYYY"
                        date={diaEntrega ? moment(diaEntrega) : ""}
                        locale="pt"
                        // eslint-disable-next-line no-shadow
                        onDateChange={diaEntrega => this.onChangeDateTest(diaEntrega, "diaEntrega")}
                        isOutsideRange={() => false}
                        readOnly
                      />
                    </FormItem>
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <label>Quem recebeu</label>
                    <TextInput
                      id="responsavelRecebimento"
                      value={responsavelRecebimento}
                      onChange={e => this.onChangeText(e)}
                      placeholder="Quem recebeu"
                    />
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <TextInput
                      labelText="Quem entregou"
                      id="responsavelEntrega"
                      value={responsavelEntrega}
                      onChange={e => this.onChangeText(e)}
                      placeholder="Quem entregou"
                    />
                  </div>
                </div>
              </div>
              <div className="bx--modal-footer">
                <div className="bx--row btn-actions">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <div className="f-right">
                      <button
                        className="bx--btn btn-secondary-outlined h-sm-margin"
                        type="button"
                        onClick={() => { this.toggleModal('openModalFinalizarPedido') }}
                      >
                        Cancelar
                      </button>
                      <button
                        className="bx--btn btn-secondary-color h-sm-margin"
                        type="button"
                        onClick={async () => {
                          await this.trocaStatusPedidoEntregue()
                        }}
                      >
                        Tenho certeza
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalDm>
        </div>


        <div className="md-cancel-request-agency">
          <ModalDm
            openModal={this.toggleModalAlertDesigner}
            heading="Atenção! Pedidos aguardando fechamento"
            hiddenModal={this.toggleModalAlertDesigner}
            openMd={this.state.modalAlertDesigner}
          >
            <div>
              <div className="bx--modal-content">
                <p className="question">
                  Os seguintes pedidos estão na fila de <strong>Fechamento de Arquivo</strong> há mais de 3 dias sem alteração:
                </p>
                <br />
                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  <ul>
                    {this.state.pedidosAtrasados.map((pedido, index) => (
                      <li key={index} style={{ marginBottom: '5px' }}>
                        <strong>- {pedido}</strong>
                      </li>
                    ))}
                  </ul>
                </div>
                <br />
                <p>Por favor, verifique-os assim que possível.</p>
              </div>
              <div className="bx--modal-footer">
                <div className="bx--row btn-actions">
                  <div className="bx--col-md-12 bx--col-xs-12">
                    <div className="f-right">
                      <button
                        className="bx--btn btn-secondary-color h-sm-margin"
                        type="button"
                        onClick={this.toggleModalAlertDesigner}
                      >
                        Entendido
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalDm>
        </div>
      </div>
    )
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Agency/Requests/Admin/List.js